import {Component, Input} from '@angular/core';

@Component({
  selector: 'ms-stat-card-widget',
  imports: [],
  templateUrl: './stat-card-widget.component.html',
  styleUrl: './stat-card-widget.component.scss'
})
export class StatCardWidgetComponent {

  constructor() {
  }

  @Input() title: string = '';
  @Input() value: number = 0;
  @Input() progressPercent: number = 0;
  @Input() icon: string = '';
}
